import { ProgressSpinner } from "primereact/progressspinner";
import { useMedicalCenterFund } from "../hooks/queries";
import Dashboard from "../Layout/Dashboard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressBar } from "primereact/progressbar";

const getConsumedColor = (consumed) => {
  if (consumed >= 85) {
    return "#dc2626";
  } else if (consumed >= 70) {
    return "#f59e0b";
  }
  return "#16a34a";
};

export default function Balance() {
  const { data, isLoading } = useMedicalCenterFund({
    enabled: true,
    forBalance: true,
  });
  return (
    <Dashboard headerTitle="Saldo">
      {isLoading && <ProgressSpinner />}
      <DataTable
        value={data || []}
        emptyMessage="No hay datos disponibles"
        rowHover
      >
        <Column field="client_name" header="Cliente" style={{ width: "30%" }} />
        <Column
          header="Saldo consumido"
          body={(row) => (
            <div className="flex gap-2 align-items-center">
              <ProgressBar
                value={row.consumed}
                showValue={false}
                color={getConsumedColor(row.consumed)}
                style={{ maxHeight: "0.8rem", width: "100%" }}
              />
              <span>{row.consumed.toFixed(2)}%</span>
            </div>
          )}
        />
      </DataTable>
    </Dashboard>
  );
}
